// extracted by mini-css-extract-plugin
export default {"seleccion_generos":"Generos_seleccion_generos__Z9GeL","generos":"Generos_generos__mUrjt","activo":"Generos_activo__0AIco","no_activo":"Generos_no_activo__8Ilpp"};